import { render, staticRenderFns } from "./ProjectAddDependencyModal.vue?vue&type=template&id=07baab30&"
import script from "./ProjectAddDependencyModal.vue?vue&type=script&lang=js&"
export * from "./ProjectAddDependencyModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports